import { useContext, useEffect, useState } from 'react';

import { Context } from '@swf/components/StarsWizard/StarsWizard';
import useWizardContext from '@swf/core/hooks/useWizardContext';

const useRmfFirstScreen = () => {
  const [isFirstScreen, setIsFirstScreen] = useState<boolean>();

  const {
    data: { fieldsMap }
  } = useWizardContext();
  const wizard = useContext(Context);

  useEffect(() => {
    if (!wizard) {
      return;
    }

    const currentScreen = `#${Object.keys(wizard.state.meta)}`;
    const firstRmfScreen = fieldsMap.find((field) => field.pageIdRef?.includes('rmf'));
    const isRmfCurrentScreen = currentScreen?.includes('rmf');

    if (!firstRmfScreen || !isRmfCurrentScreen) {
      setIsFirstScreen(true);
    } else if (firstRmfScreen.pageIdRef === currentScreen) {
      setIsFirstScreen(true);
    } else {
      setIsFirstScreen(false);
    }
  }, [wizard, fieldsMap]);

  return isFirstScreen;
};

export default useRmfFirstScreen;
